/** @format */

import JSEncrypt from 'jsencrypt';

/**
 * 使用 RSA 加密数据（需先调用 initPublicKey 初始化）
 * @param {string} data - 需要加密的数据
 * @returns {string} - 加密后的字符串（失败返回空）
 */

export const encodeStr = (text, publicKey) => {
	// RSA（非对称加密）
	const JSE = new JSEncrypt();
	// 设置公钥
	JSE.setPublicKey(publicKey);
	return JSE.encrypt(text);
};
